/* Revitalized: Founding 950 pre-sale. Tier picker + quantity, reserve → checkout, close date, sticky bar */
(function () {
  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function init() {
    var form = document.querySelector('[data-rv-form]');
    var forms = $all('[data-rv-form]');
    var qtyInputs = $all('[data-rv-qty] input');
    var tierInputs = $all('[data-rv-tier]');
    var qtyFields = $all('[data-rv-qty-field]');
    var max = form ? parseInt(form.dataset.max, 10) || 1 : (qtyInputs.length ? parseInt(qtyInputs[0].max, 10) || 1 : 1);
    var checked = tierInputs.filter(function (i) { return i.checked; })[0];
    var qty = checked ? parseInt(checked.value, 10) : 1;
    var closed = false;

    function setQty(n) {
      qty = Math.max(1, Math.min(max, n));
      qtyInputs.forEach(function (i) { i.value = qty; });
      qtyFields.forEach(function (i) { i.value = qty; });
      tierInputs.forEach(function (i) { i.checked = parseInt(i.value, 10) === qty; });
      $all('[data-rv-qty-step="-1"]').forEach(function (b) { b.disabled = qty <= 1; });
      $all('[data-rv-qty-step="1"]').forEach(function (b) { b.disabled = qty >= max; });
      // Button labels follow the quantity: "Reserve 3 bottles for $45" (deposit is per bottle)
      var dep = form ? parseFloat(form.dataset.deposit) : NaN;
      if (!isNaN(dep) && !closed) {
        var amt = '$' + (Math.round(dep * qty * 100) / 100).toString().replace(/\.(\d)$/, '.$10');
        $all('[data-rv-reserve] [data-rv-label]').forEach(function (l) {
          if (l.closest('[data-rv-sticky]')) {
            l.textContent = qty > 1 ? 'Reserve ' + qty + ' Bottles \u00b7 ' + amt : 'Reserve My Bottle \u00b7 ' + amt;
          } else {
            l.textContent = qty > 1 ? 'Reserve ' + qty + ' bottles for ' + amt : 'Reserve my bottle for ' + amt;
          }
        });
      }
      // Free shipping + bonuses come with the 3-bottle 90-Day Founding Kit only
      $all('[data-rv-ship-nudge]').forEach(function (el) {
        el.classList.toggle('is-unlocked', qty >= 3);
        el.innerHTML = qty >= 3
          ? '<span aria-hidden="true">&#10003;</span> <strong>Free shipping + bonuses included.</strong>'
          : 'Make it 3 bottles: <strong>free shipping + 2 bonuses.</strong>';
      });
    }
    $all('[data-rv-qty-step]').forEach(function (btn) {
      btn.addEventListener('click', function () { setQty(qty + parseInt(btn.dataset.rvQtyStep, 10)); });
    });
    tierInputs.forEach(function (i) {
      i.addEventListener('change', function () { if (i.checked) setQty(parseInt(i.value, 10)); });
    });

    // Reservation window
    var root = document.querySelector('[data-rv-close-date]');
    var closeDate = root && root.dataset.rvCloseDate;
    if (closeDate && /^\d{4}-\d{2}-\d{2}$/.test(closeDate)) {
      var parts = closeDate.split('-');
      var end = new Date(+parts[0], +parts[1] - 1, +parts[2], 23, 59, 59);
      var label = end.toLocaleDateString('en-US', { month: 'long', day: 'numeric' });
      closed = Date.now() > end.getTime();
      $all('[data-rv-close-line]').forEach(function (li) {
        li.hidden = false;
        li.innerHTML = closed ? '<strong>Reservations are closed.</strong>' : '<strong>Reservations close ' + label + '.</strong>';
      });
      $all('[data-rv-close-text]').forEach(function (el) { el.textContent = closed ? 'Reservations are closed.' : 'Reservations close ' + label + '.'; });
    }
    setQty(qty);
    if (closed) {
      $all('[data-rv-reserve]').forEach(function (b) {
        b.disabled = true;
        var l = b.querySelector('[data-rv-label]'); if (l) l.textContent = 'Reservations closed';
      });
    }

    // Reserve: empty the cart (keeps the 3-bottle limit honest), add, go straight to checkout
    var busy = false;
    function showError(msg) {
      $all('.rv-reserve-error').forEach(function (e) { e.textContent = msg; e.hidden = false; });
    }
    function reserve(e) {
      if (e) e.preventDefault();
      if (!form || busy || closed) return;
      busy = true;
      var buttons = $all('[data-rv-reserve]');
      buttons.forEach(function (b) {
        b.disabled = true;
        var l = b.querySelector('[data-rv-label]'); if (l) { l.dataset.orig = l.textContent; l.textContent = 'Reserving…'; }
      });
      var item = { id: parseInt(form.dataset.variantId, 10), quantity: qty };
      if (form.dataset.sellingPlan) item.selling_plan = parseInt(form.dataset.sellingPlan, 10);
      // Keep any line-item properties apps add to the form (Essent's campaign id + shipping note)
      var props = {};
      $all('input[name^="properties["]', form).forEach(function (i) {
        var key = i.name.slice(11, -1);
        if (key && i.value !== '') props[key] = i.value;
      });
      if (Object.keys(props).length) item.properties = props;
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      fetch(root + 'cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
        .then(function () {
          return fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [item] })
          });
        })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.body && (res.body.description || res.body.message) || 'Something went wrong.');
          window.location.href = root + 'checkout';
        })
        .catch(function (err) {
          busy = false;
          buttons.forEach(function (b) {
            b.disabled = false;
            var l = b.querySelector('[data-rv-label]'); if (l && l.dataset.orig) l.textContent = l.dataset.orig;
          });
          showError(err.message + ' Please try again.');
          var box = document.querySelector('[data-rv-reserve-box]');
          if (box) box.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
    }
    forms.forEach(function (f) { f.addEventListener('submit', reserve); });
    $all('[data-rv-reserve]').forEach(function (b) {
      if (b.type !== 'submit') b.addEventListener('click', reserve);
    });

    // Sticky mobile bar: shows whenever no reserve box is on screen
    var sticky = document.querySelector('[data-rv-sticky]');
    var boxes = $all('[data-rv-reserve-box]');
    if (sticky && boxes.length && 'IntersectionObserver' in window) {
      var visible = new Set();
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) visible.add(en.target); else visible.delete(en.target);
        });
        sticky.classList.toggle('is-visible', visible.size === 0 && !closed);
      }, { threshold: 0 });
      boxes.forEach(function (b) { io.observe(b); });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
